
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-planter",
      function () {
        return require("private-next-pages/become-a-planter/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-planter"])
      });
    }
  